import AxiosCustom from "../../../common/components/apiConfig";

export const insert_offline_order = (data) => {
  let config = { url: "insert_request" };

  let _data = {
    table: "offlineorder",
    method_type: "insert_offline_order",
    data: {
      ...data,
    },
  };

  return AxiosCustom(config, _data);
};
